export default {
      id: "i-analytic-services-03-usage",
      viewBox: "0 0 126 96",
      url: __webpack_public_path__ + "img/sprite.svg#i-analytic-services-03",
      toString: function () {
        return this.url;
      }
    }